import { render, staticRenderFns } from "./ContractItem.vue?vue&type=template&id=f891abc8"
import script from "./ContractItem.vue?vue&type=script&lang=ts"
export * from "./ContractItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports